import { render } from "./Prescription.vue?vue&type=template&id=28b2496e&scoped=true"
import script from "./Prescription.vue?vue&type=script&lang=js"
export * from "./Prescription.vue?vue&type=script&lang=js"

import "./Prescription.vue?vue&type=style&index=0&id=28b2496e&scoped=true&lang=css"

import exportComponent from "/home/tuhin/Downloads/homeo/html/clientApp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b2496e"]])

export default __exports__